import { StartProjectForm } from '../../models/startProject';
import client, { ApiResponse } from '../config/axiosConfig';

export const PostContactRequest = async (values: StartProjectForm): Promise<ApiResponse> => await client.post('contact-requests', values);
